import { render } from "./MyTooltip.vue?vue&type=template&id=bc7e00dc&scoped=true"
import script from "./MyTooltip.vue?vue&type=script&lang=js"
export * from "./MyTooltip.vue?vue&type=script&lang=js"

import "./MyTooltip.vue?vue&type=style&index=0&id=bc7e00dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7e00dc"]])

export default __exports__